import { Box } from "@material-ui/core";

export function Loading({ isBackgroundTransparent }) {
  return (
    <Box
      sx={{
        boxShadow: 3,
        backgroundColor: isBackgroundTransparent ? "transparent" : "rgba(255, 255, 255, 0.9)",
        borderRadius: "8px",
        padding: "20px",
      }}
    >
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ gap: "10px" }}
      >
        <div className="loader"></div>
        <div>Loading...</div>
      </div>
    </Box>
  );
}
